import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";

export const NOTIFICATION = "notification";

export const getInfo = createAsyncThunk(
    `${NOTIFICATION}/getInfo`,
    async () => {
        const response = await client.get('/notification/info')
        return response.data
    }
)
export const getNotifications = createAsyncThunk(
    `${NOTIFICATION}/getNotifications`,
    async () => {
        const response = await client.get('/notification')
        return response.data
    }
)
export const readNotification = createAsyncThunk(
    `${NOTIFICATION}/readNotification`,
    async (id) => {
        const response = await client.post(`/notification/${id}`, {})
        return response.data
    }
)

export const getPersonalSettings = createAsyncThunk(
    `${NOTIFICATION}/getPersonalSettings`,
    async () => {
        const response = await client.get('/personalSettings')
        return response.data
    }
)

export const updateSettings = createAsyncThunk(
    `${NOTIFICATION}/updateSettings`,
    async (body) => {
        const response = await client.post('/personalSettings', body)
        return response.data
    }
)